package core.model

@OptIn(ExperimentalJsExport::class)
@JsExport
data class ConversionParams(
    val convertPitch: Boolean = false,
)
